module.exports = __webpack_public_path__ + "static/media/bg-7.ba470e4a.png";